import { IApplicationState } from '../../types/redux';

export const getRandomBoolean = (state: IApplicationState): boolean => {
  return state.randomBoolean;
};
